import { useTheme } from "@/components/theme/theme-provider";
import { appActions } from "@/store/appSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router";

export const useMobileRedirectedPage = () => {
  const dispatch = useDispatch();
  const [queryParams] = useSearchParams();
  const token = queryParams.get("token");
  const activeFirmId = queryParams.get("activeFirmId");
  const isDark = queryParams.get("isDark") == "true";
  const { setTheme } = useTheme();

  useEffect(() => {
    if (token && activeFirmId) {
      dispatch(appActions.successfulLogin({ token }));
      dispatch(appActions.setActiveFirm({ firmGuid: activeFirmId, firmName: "" }));
    }
  }, [token, activeFirmId]);

  useEffect(() => {
    if (isDark) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }, [isDark, setTheme]);

  if (!token || !activeFirmId) {
    return false;
  }

  return true;
};
